import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function Denials() {
  return <V20Embed view="focus" testid="denials-view" />;
}
